module.exports = __webpack_public_path__ + "static/img/sustainable-introduction_202512.e729139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-introduction_202512.jpg
// module id = +MKq
// module chunks = 98